import React from "react";
import { Box } from "@chakra-ui/react";

export function BabyIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <Box as="circle" cx={128} cy={128} r={96} fill="new.green.150" opacity={0.3} />
      <Box
        as="circle"
        cx={128}
        cy={128}
        r={96}
        fill="none"
        stroke="new.green.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
      <Box as="circle" fill="new.green.500" cx={92} cy={128} r={12} />
      <Box as="circle" fill="new.green.500" cx={164} cy={128} r={12} />
      <Box
        as="path"
        d="M154.5 168a47.9 47.9 0 0 1-53 0M128 32c-16 20-16 40-16 40a16 16 0 0 0 32 0"
        fill="none"
        stroke="new.green.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
    </Box>
  );
}
